(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["layout-blog"] && !Shopify.designMode) return;
  try {
    
  class BlogTrigger {
    constructor() {
      this.triggers = document.querySelectorAll('[data-blog-trigger]');
      this.addEventListeners();
    }

    addEventListeners() {
      this.triggers.forEach(trigger => {
        trigger.addEventListener('click', event => {
          event.preventDefault();

          // Remove active class from all triggers
          this.triggers.forEach(t => t.classList.remove('!border-yellow'));

          // Add active class to clicked trigger
          event.target.classList.add('!border-yellow');

          const target = document.querySelector('[data-blog="' + event.target.getAttribute('href').substring(1) + '"]');
          if (target) {
            const targetTop = window.pageYOffset + target.getBoundingClientRect().top - 130; // Subtract the height of the header
            window.scrollTo({ top: targetTop, behavior: 'smooth' });
          }
        });
      });
    }
  }

  document.addEventListener('DOMContentLoaded', function() {
    new BlogTrigger();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog"]) return;
  try {
    
  class BlogTrigger {
    constructor() {
      this.triggers = document.querySelectorAll('[data-blog-trigger]');
      this.addEventListeners();
    }

    addEventListeners() {
      this.triggers.forEach(trigger => {
        trigger.addEventListener('click', event => {
          event.preventDefault();
          const target = document.querySelector('[data-blog="' + event.target.getAttribute('href').substring(1) + '"]');
          if (target) {
            const targetTop = window.pageYOffset + target.getBoundingClientRect().top - 130; // Subtract the height of the header
            window.scrollTo({ top: targetTop, behavior: 'smooth' });
          }
        });
      });
    }
  }

  document.addEventListener('DOMContentLoaded', function() {
    new BlogTrigger();
  });

  } catch(e) { console.error(e); }
})();
})();
